
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PopularChannels"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"channels"},"name":{"kind":"Name","value":"channel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"9998b01b-515a-542c-a8a9-bb853177dcad","block":false},{"kind":"StringValue","value":"c13ffb34-aa12-5e2f-a596-882edf8b24b0","block":false},{"kind":"StringValue","value":"b18c979c-441e-5778-a9a1-0e579f3a1e9c","block":false},{"kind":"StringValue","value":"2afc1d99-b3b2-5f72-b1ac-47ea21115649","block":false},{"kind":"StringValue","value":"4a3174a2-e400-54f0-bc92-c942c77188f2","block":false},{"kind":"StringValue","value":"6039948f-71ce-5b95-8307-0d837f5d83f6","block":false},{"kind":"StringValue","value":"271019a5-7687-5c56-b0b3-9a02db629e6f","block":false},{"kind":"StringValue","value":"1506e3f6-b6e6-565c-8856-53f6007294de","block":false},{"kind":"StringValue","value":"d4e8e311-4cde-5b51-94a6-269f276d29a7","block":false},{"kind":"StringValue","value":"80051d4d-43eb-5b8e-9236-8d56876d2025","block":false},{"kind":"StringValue","value":"687bb57e-cf5d-5700-ac44-9f51839900f0","block":false},{"kind":"StringValue","value":"c09248c9-85c4-53eb-a7a4-aa514b2bef9e","block":false}]}}]}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChannelSummary"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"users_aggregate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":1128}};
    doc.loc.source = {"body":"#import \"../fragments/ChannelSummary.gql\"\n\n# Hardcoded popular channels\nquery PopularChannels {\n  channels: channel(\n    order_by: { title: asc }\n    where: {\n      id: {\n        _in: [\n          \"9998b01b-515a-542c-a8a9-bb853177dcad\"\n          \"c13ffb34-aa12-5e2f-a596-882edf8b24b0\"\n          \"b18c979c-441e-5778-a9a1-0e579f3a1e9c\"\n          \"2afc1d99-b3b2-5f72-b1ac-47ea21115649\"\n          \"4a3174a2-e400-54f0-bc92-c942c77188f2\"\n          \"6039948f-71ce-5b95-8307-0d837f5d83f6\"\n          \"271019a5-7687-5c56-b0b3-9a02db629e6f\"\n          \"1506e3f6-b6e6-565c-8856-53f6007294de\"\n          \"d4e8e311-4cde-5b51-94a6-269f276d29a7\"\n          \"80051d4d-43eb-5b8e-9236-8d56876d2025\"\n          \"687bb57e-cf5d-5700-ac44-9f51839900f0\"\n          \"c09248c9-85c4-53eb-a7a4-aa514b2bef9e\"\n        ]\n      }\n    }\n  ) {\n    ...ChannelSummary\n    users_aggregate {\n      aggregate {\n        count\n      }\n    }\n  }\n}\n\n# Real popular channels\n# query PopularChannels {\n# \tchannels: channel(order_by: { users_aggregate: { count: desc } }, limit: 10) {\n# \t\t...ChannelSummary\n# \t\tusers_aggregate {\n# \t\t\taggregate {\n# \t\t\t\tcount\n# \t\t\t}\n# \t\t}\n# \t}\n# }\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../fragments/ChannelSummary.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["PopularChannels"] = oneQuery(doc, "PopularChannels");
        
